import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";
import { TID } from "@/lib/testIds";

export default function ProcessSection() {
  const { t } = useI18n();
  const steps = t("process.steps");

  return (
    <section
      data-testid={TID.process}
      className="relative bg-[color:var(--gc-paper)] py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 gc-grid-bg opacity-60 pointer-events-none" />
      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <p className="gc-eyebrow">{t("process.eyebrow")}</p>
            <h2 className="mt-6 font-display text-4xl md:text-5xl lg:text-[56px] leading-[1.02] tracking-tight font-[700] text-[color:var(--gc-ink)]">
              {t("process.title")}
            </h2>
          </div>
          <div className="lg:col-span-7">
            <p className="text-lg leading-relaxed text-[color:var(--gc-graphite)]">
              {t("process.lead")}
            </p>
            <p className="mt-4 text-base leading-relaxed text-[color:var(--gc-steel)]">
              {t("process.lead2")}
            </p>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[color:var(--gc-line)] border border-[color:var(--gc-line)]">
          {Array.isArray(steps) &&
            steps.map((s, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.45, delay: (i % 4) * 0.05 }}
                className="relative bg-white p-7 min-h-[200px] group hover:bg-[color:var(--gc-ink)] hover:text-white transition-colors duration-300"
              >
                <div className="flex items-start justify-between">
                  <span className="font-mono text-[11px] tracking-[0.18em] text-[color:var(--gc-mist)] group-hover:text-white/50">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="w-2 h-2 bg-[color:var(--gc-red)]" />
                </div>
                <h3 className="mt-8 font-display font-[700] text-xl leading-tight text-[color:var(--gc-ink)] group-hover:text-white tracking-tight">
                  {s.t}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-[color:var(--gc-steel)] group-hover:text-white/70">
                  {s.d}
                </p>
              </motion.div>
            ))}
        </div>
      </div>
    </section>
  );
}
